export function s3AssetUrl(slug: string): string {
  return `https://s3.lexoya.com/assets/${slug}.svg`
}

export function s3LandingUrl(slug: string): string {
  return `https://s3.lexoya.com/assets/landings/${slug}.webp`
}

export function s3LandingFileUrl(file: string): string {
  return `https://s3.lexoya.com/assets/landings/${file}`
}
